
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class BusinessDtoModel extends Model<BusinessDtoModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'name', type: 'string', languageString: 'businessDto.property.name' },
		{ name: 'address', type: 'string', languageString: 'businessDto.property.address' },
		{ name: 'city', type: 'string', languageString: 'businessDto.property.city' },
		{ name: 'zip', type: 'string', languageString: 'businessDto.property.zip' },
		{ name: 'phone', type: 'string', languageString: 'businessDto.property.phone' },
		{ name: 'homepage', type: 'string', languageString: 'businessDto.property.homepage' },
		{ name: 'email', type: 'string', languageString: 'businessDto.property.email' },
		{ name: 'businessId', type: 'string', languageString: 'businessDto.property.businessId' },
		{ name: 'industryCodes', type: 'string[]', languageString: 'businessDto.property.industryCodes', isArray: true },
		{ name: 'formOfCompany', type: 'string', languageString: 'businessDto.property.formOfCompany' },
		{ name: 'foundationDate', type: 'string', languageString: 'businessDto.property.foundationDate' },
		{ name: 'domain', type: 'string', languageString: 'businessDto.property.domain' }
	];
	[key: string]: any;
	
	public name: string;
	public address: string;
	public city: string;
	public zip: string;
	public phone: string;
	public homepage: string;
	public email: string;
	public businessId: string;
	public industryCodes: string[];
	public formOfCompany: string;
	public foundationDate: string;
	public domain: string;
    
	constructor(){
		super();
		this.name = '';
		this.address = '';
		this.city = '';
		this.zip = '';
		this.phone = '';
		this.homepage = '';
		this.email = '';
		this.businessId = '';
		this.industryCodes = [];
		this.formOfCompany = '';
		this.foundationDate = '';
		this.domain = '';
		
	}
	getProperties(){
		return BusinessDtoModel.classProperties;
	}
}

